import Vue from 'vue';
import template from './price-list.html';
import { DialogBox, dialogDefaultConfiguration, dialogDefaultMethods } from "./dialog-box";

const tagName = 'dialog-price-list';

export const priceListDialogDefinition = {
    ...dialogDefaultConfiguration,
    template : template,
    methods  : {
        ...dialogDefaultMethods
    }
};

Vue.component( tagName, priceListDialogDefinition );

export class PriceListDialog extends DialogBox {

    constructor(content) {
        super();
        this.content  = content;
    }

    getComponentTag() {
        return tagName;
    }

    getComponentData() {
        return {
            content   : this.content
        };
    }


}

